import axios from 'axios'
import store from '../store';
import AuthService from '../services/AuthService';
import router from '../router'

export default function setup() {

    if (store.state.auth.authenticated) {
        axios.interceptors.request.use(function (config) {
            config.headers.Authorization = `Bearer ${AuthService.getToken()}`;
            return config;
        }, function (err) {
            return Promise.reject(err);
        });
        axios.interceptors.response.use((response) => {
            if (401 !== response.status) {
                return response;
            }
            if (!AuthService.getRememberMe()) {
                AuthService.logOut();
                router.push('login');
            }
            let originalRequest = response.config;
            if (!originalRequest.url.includes('api/token/refresh')) {
                if (!originalRequest._retry) {
                    originalRequest._retry = true;
                    return AuthService.refreshToken().then((resolve) => {
                        if (!resolve) {
                            AuthService.logOut();
                            store.commit('clearAuthentication');
                            router.push('login');
                        } else {
                                originalRequest.headers.Authorization = `Bearer ${AuthService.getToken()}`;
                                return axios(originalRequest);
                        }
                    });
                }
            }
        }, function (error) {
            let originalRequest = error.config;
            if (error.response.status === 401) {
                if (!AuthService.getRememberMe()) {
                    AuthService.logOut();
                    router.push('login');
                }
                if (!originalRequest._retry) {
                    originalRequest._retry = true;
                    return AuthService.refreshToken().then((resolve) => {
                        if (!resolve) {
                            AuthService.logOut();
                            store.commit('clearAuthentication');
                            router.push('login');
                        } else {
                            originalRequest.headers.Authorization = `Bearer ${AuthService.getToken()}`;
                            return axios(originalRequest);
                        }
                    });
                }
            } else if (error.response.status === 404 && !originalRequest._retry) {
                router.push({'name': '404'});
            } else if (error.response.status === 500 && !originalRequest._retry) {
                router.push({'name': '500'});
            } else if (error.response.status === 403 && !originalRequest._retry) {
                router.push({'name': '403'});
            }
            return Promise.reject(error)
        })
    }
}